function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.08507 13.0446C4.08507 12.3355 4.13471 11.6341 4.23153 10.9441C4.25962 10.7439 4.47221 10.626 4.65763 10.7066C4.69507 10.7229 4.73258 10.739 4.77027 10.7549C5.21148 10.9416 5.65905 11.1068 6.11221 11.2509C6.26096 11.2981 6.34941 11.4495 6.31971 11.6027C6.21026 12.1674 6.15416 12.7467 6.15416 13.3347C6.15416 14.8971 6.54987 16.3985 7.293 17.7254C7.33783 17.8054 7.41704 17.8611 7.50756 17.8762C7.51305 17.8771 7.51853 17.8781 7.52402 17.8789C7.77651 17.9205 7.9654 17.649 7.84018 17.4259C7.16057 16.215 6.77252 14.8194 6.77252 13.3347C6.77252 12.817 6.81998 12.3103 6.9103 11.8184C6.94215 11.645 7.11111 11.5329 7.28277 11.5729C8.4328 11.8407 9.61401 11.9756 10.8158 11.9756C12.9123 11.9756 14.9463 11.5649 16.8613 10.755C17.1678 10.6253 17.4688 10.4858 17.7646 10.3376C17.8572 10.2912 17.92 10.2008 17.9325 10.0978C17.9621 9.85433 17.7087 9.67742 17.4895 9.78742C15.4434 10.8137 13.1716 11.3573 10.8158 11.3573C9.67199 11.3573 8.5479 11.229 7.45979 10.9799C7.28074 10.9389 7.17822 10.7505 7.23872 10.577C8.3819 7.30241 11.5011 4.94659 15.1606 4.94659C15.746 4.94659 16.3173 5.00727 16.8691 5.12209C16.9843 5.14607 17.0767 5.02503 17.0233 4.92016C16.9682 4.81191 16.911 4.7049 16.8516 4.59922C16.8066 4.51906 16.7272 4.46344 16.6365 4.44854C16.1532 4.36919 15.6601 4.3283 15.1607 4.3283C12.755 4.3283 10.4932 5.26511 8.79217 6.96621C7.79612 7.96229 7.06235 9.15064 6.625 10.4475C6.57104 10.6075 6.39997 10.6964 6.2392 10.6447C5.69389 10.4697 5.15976 10.2633 4.63906 10.0262C4.50523 9.96531 4.4333 9.81854 4.46624 9.67524C5.0859 6.97908 6.44848 4.50415 8.45295 2.49965C9.25989 1.69275 10.1433 0.990363 11.0864 0.397946C11.1626 0.350099 11.1393 0.233626 11.0506 0.218509L10.52 0.128017C10.4431 0.114904 10.3639 0.131568 10.2993 0.175337C9.4845 0.727043 8.72119 1.35694 8.01568 2.06245C6.58942 3.4887 5.46959 5.14962 4.68737 6.99912C4.37754 7.73163 4.12635 8.48162 3.93401 9.24584C3.88472 9.44184 3.66098 9.53767 3.48506 9.43815C3.23704 9.29777 2.9927 9.15008 2.75244 8.99511C2.64311 8.92459 2.58858 8.79395 2.61786 8.66717C2.77115 8.00423 2.85025 7.31918 2.85025 6.62193C2.85025 5.50371 2.64761 4.41669 2.26008 3.40253C2.21455 3.28339 2.05491 3.26184 1.97806 3.36362L1.81353 3.58137C1.75148 3.6635 1.73369 3.77122 1.76758 3.86842C2.0683 4.73126 2.23196 5.6578 2.23196 6.62189C2.23196 7.09193 2.19297 7.55304 2.11819 8.00219C2.08012 8.23092 1.8118 8.33688 1.62934 8.19376C1.32155 7.95231 0.828626 7.50438 0.518479 7.21758C0.391635 7.1003 0.1846 7.16818 0.152995 7.33799C0.141921 7.39768 0.131409 7.45752 0.121425 7.5176C0.10462 7.61934 0.1383 7.72333 0.213604 7.79379C0.676189 8.22653 1.16163 8.62868 1.66861 8.99898C1.77725 9.07832 1.82126 9.21969 1.77742 9.34685C1.48735 10.189 1.06649 10.9707 0.539572 11.6681C0.477873 11.7498 0.462615 11.8573 0.496154 11.954C0.532436 12.0587 0.570545 12.1624 0.610553 12.2652C0.646939 12.3587 0.771251 12.3783 0.834673 12.3005C1.44161 11.5561 1.92009 10.7289 2.25801 9.84617C2.32709 9.66575 2.5421 9.59298 2.70681 9.69394C2.97284 9.85703 3.24389 10.0121 3.51987 10.1591C3.63529 10.2205 3.69843 10.3495 3.67698 10.4785C3.53713 11.3206 3.46661 12.1772 3.46661 13.0446C3.46661 14.1296 3.57675 15.1978 3.79518 16.2414C3.81128 16.3183 3.85638 16.3865 3.92125 16.4309C4.02858 16.5044 4.1376 16.5756 4.2482 16.6444C4.36565 16.7176 4.51215 16.6115 4.48058 16.4768C4.2199 15.3649 4.08507 14.2152 4.08507 13.0446Z",
  fill: "url(#paint0_linear_1921_1258)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.56496 9.99209C5.13829 10.257 5.72814 10.4846 6.33145 10.6739C6.4417 10.7085 6.55947 10.6488 6.59523 10.5389C7.02853 9.20653 7.77328 7.98566 8.79267 6.96627C10.4938 5.26517 12.7555 4.32836 15.1612 4.32836C15.5972 4.32836 16.0284 4.35954 16.4524 4.42026C16.5829 4.43893 16.6743 4.29479 16.6037 4.18355C15.4139 2.3091 13.5504 0.904501 11.3535 0.310888C11.2974 0.295736 11.2374 0.304631 11.188 0.335146C10.2069 0.940536 9.28914 1.66409 8.45348 2.49975C6.42898 4.52425 5.05926 7.02864 4.44842 9.75609C4.4269 9.85213 4.47559 9.95078 4.56496 9.99209Z",
  fill: "url(#paint1_radial_1921_1258)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.20227 10.6836C7.16297 10.8014 7.23405 10.927 7.35485 10.9556C8.47559 11.2207 9.63508 11.3574 10.8157 11.3574C13.2155 11.3574 15.5282 10.7933 17.6039 9.72943C17.8435 9.6066 17.996 9.36237 17.9989 9.09307C17.9993 9.06206 17.9995 9.03099 17.9995 8.99991C17.9995 7.68932 17.7188 6.44451 17.2151 5.32141C17.1762 5.23447 17.0972 5.17242 17.0042 5.1515C16.4108 5.01773 15.7939 4.94672 15.1606 4.94672C11.4615 4.94675 8.31444 7.35379 7.20227 10.6836Z",
  fill: "url(#paint2_radial_1921_1258)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M3.59746 9.50106C3.7191 9.56849 3.87153 9.50201 3.90437 9.36687C4.10026 8.56081 4.36147 7.77036 4.68761 6.99924C5.46987 5.14975 6.58967 3.48886 8.01596 2.06258C8.67953 1.39901 9.39422 0.80237 10.1548 0.27471C10.2408 0.215015 10.2082 0.0800506 10.1043 0.0673241C9.7423 0.0229921 9.37372 0 8.99977 0C6.30884 0 3.89407 1.18128 2.24482 3.05321C2.19226 3.11287 2.17936 3.19728 2.20889 3.27107C2.62992 4.32252 2.85049 5.45533 2.85049 6.62202C2.85049 7.34107 2.7664 8.04711 2.60356 8.72928C2.58285 8.81615 2.61741 8.90717 2.69218 8.95593C2.98795 9.14883 3.28991 9.33052 3.59746 9.50106Z",
  fill: "url(#paint3_radial_1921_1258)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M9.00044 18.0001C13.3987 18.0001 17.0594 14.8449 17.8442 10.6746C17.8761 10.5053 17.7015 10.3708 17.5463 10.4456C17.3213 10.5541 17.0934 10.6575 16.8622 10.7552C14.9472 11.5652 12.9132 11.9759 10.8167 11.9759C9.58073 11.9759 8.36654 11.8331 7.18564 11.55C7.06977 11.5223 6.95407 11.5976 6.93108 11.7145C6.82789 12.239 6.77344 12.7807 6.77344 13.335C6.77344 14.8616 7.18371 16.2939 7.89924 17.5282C8.05984 17.8053 8.35075 17.9821 8.67078 17.994C8.78015 17.998 8.89005 18.0001 9.00044 18.0001Z",
  fill: "url(#paint4_radial_1921_1258)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M0.249398 7.82705C0.184535 7.76673 0.0786444 7.806 0.0678163 7.89385C0.0232382 8.25642 0 8.62559 0 9.00022C0 9.89005 0.129621 10.7495 0.3703 11.5613C0.399585 11.6601 0.529944 11.6831 0.591222 11.6002C1.10823 10.9014 1.51963 10.1198 1.80105 9.27922C1.83058 9.19097 1.8 9.09422 1.72466 9.0397C1.21043 8.66764 0.718241 8.26303 0.249398 7.82705Z",
  fill: "url(#paint5_radial_1921_1258)"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M6.15509 13.3346C6.15509 12.7171 6.21696 12.1091 6.33752 11.5176C6.35907 11.4118 6.29571 11.308 6.19267 11.2758C5.7123 11.1259 5.23815 10.9523 4.77113 10.7548L4.54335 10.6584C4.41517 10.6041 4.27033 10.6856 4.24984 10.8233C4.14152 11.5522 4.08594 12.294 4.08594 13.0445C4.08594 14.3102 4.24358 15.5516 4.54768 16.7469C4.56202 16.8032 4.59897 16.8514 4.64974 16.8795C5.39209 17.2903 6.19858 17.5992 7.05048 17.7874C7.17353 17.8146 7.27088 17.6857 7.21146 17.5746C6.52159 16.2853 6.15509 14.8382 6.15509 13.3346Z",
  fill: "url(#paint6_radial_1921_1258)"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M3.4668 13.0445C3.4668 12.1544 3.54109 11.2755 3.68832 10.4122C3.70372 10.322 3.65956 10.2326 3.5786 10.1899C3.2475 10.0155 2.92346 9.82931 2.60667 9.6318C2.49329 9.5611 2.34455 9.61376 2.29839 9.7391C1.983 10.5957 1.53616 11.4016 0.968673 12.1322C0.800099 12.3492 0.762974 12.6423 0.881907 12.89C1.50466 14.1871 2.4291 15.3118 3.56436 16.1733C3.65362 16.2411 3.77892 16.1639 3.7573 16.054C3.56418 15.0699 3.4668 14.0646 3.4668 13.0445Z",
  fill: "url(#paint7_radial_1921_1258)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M2.23282 6.62197C2.23282 5.67944 2.07645 4.77279 1.78841 3.92644C1.75843 3.83827 1.64027 3.82101 1.58697 3.89741C1.02549 4.70213 0.560198 5.7296 0.286015 6.7317C0.248011 6.8706 0.291394 7.01896 0.397741 7.11609C0.705991 7.39763 1.36011 7.98762 1.75618 8.29165C1.88116 8.38759 2.06218 8.31601 2.09104 8.16115C2.1841 7.66203 2.23282 7.14763 2.23282 6.62197Z",
  fill: "url(#paint8_radial_1921_1258)"
});

var _ref11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1921_1258",
  x1: 0.117208,
  y1: 9.00361,
  x2: 17.9345,
  y2: 9.00361,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#654E48"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.445,
  stopColor: "#5F4843"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#503837"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_1921_1258",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(3.97307 4.26793) scale(13.6716 13.6716)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF931E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.325,
  stopColor: "#FF901C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.567,
  stopColor: "#FF8717"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.781,
  stopColor: "#FF770E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.978,
  stopColor: "#FF6002"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5D00"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint2_radial_1921_1258",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(3.97244 4.268) scale(13.6716 13.6716)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF931E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.325,
  stopColor: "#FF901C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.567,
  stopColor: "#FF8717"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.781,
  stopColor: "#FF770E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.978,
  stopColor: "#FF6002"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5D00"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint3_radial_1921_1258",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(3.97275 4.26804) scale(13.6716)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF931E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.325,
  stopColor: "#FF901C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.567,
  stopColor: "#FF8717"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.781,
  stopColor: "#FF770E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.978,
  stopColor: "#FF6002"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5D00"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint4_radial_1921_1258",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(3.97343 4.26817) scale(13.6716)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF931E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.325,
  stopColor: "#FF901C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.567,
  stopColor: "#FF8717"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.781,
  stopColor: "#FF770E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.978,
  stopColor: "#FF6002"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5D00"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint5_radial_1921_1258",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(3.97297 4.26827) scale(13.6716 13.6716)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF931E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.325,
  stopColor: "#FF901C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.567,
  stopColor: "#FF8717"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.781,
  stopColor: "#FF770E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.978,
  stopColor: "#FF6002"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5D00"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint6_radial_1921_1258",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(3.9734 4.26776) scale(13.6716 13.6716)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF931E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.325,
  stopColor: "#FF901C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.567,
  stopColor: "#FF8717"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.781,
  stopColor: "#FF770E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.978,
  stopColor: "#FF6002"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5D00"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint7_radial_1921_1258",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(3.9726 4.26782) scale(13.6716 13.6716)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF931E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.325,
  stopColor: "#FF901C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.567,
  stopColor: "#FF8717"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.781,
  stopColor: "#FF770E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.978,
  stopColor: "#FF6002"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5D00"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint8_radial_1921_1258",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(3.97337 4.26799) scale(13.6716 13.6716)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF931E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.325,
  stopColor: "#FF901C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.567,
  stopColor: "#FF8717"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.781,
  stopColor: "#FF770E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.978,
  stopColor: "#FF6002"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5D00"
})));

var SvgBaseketball = function SvgBaseketball(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBaseketball, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/baseketball.4661cee5.svg";
export { ForwardRef as ReactComponent };